/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Conteneur
 * 1 = Vehicule
 * 2 = Bureau
 * 3 = DSM
 * 4 = Outillage
 * 5 = AcidePicrique
 * 6 = Obus
 * 7 = Balles
 * 8 = Corporel
 * 9 = Materiel
 * 10 = CorporelMateriel
 * 11 = FuiteHydraulique
 * 12 = HuileMoteur
 * 13 = HuilesGraisses
 * 14 = Hydrocarbure
 * 15 = Verbale
 * 16 = Physique
 * 17 = Accueil
 * 18 = TriDechets
 * 19 = Independant
 * 20 = ASBL
 * 21 = DepassementQuotas
 * 22 = Reglement
 * 23 = Autre
 */
export enum RapportIncidentTypeIncidentDetail {
  Conteneur = 0,
  Vehicule = 1,
  Bureau = 2,
  DSM = 3,
  Outillage = 4,
  AcidePicrique = 5,
  Obus = 6,
  Balles = 7,
  Corporel = 8,
  Materiel = 9,
  CorporelMateriel = 10,
  FuiteHydraulique = 11,
  HuileMoteur = 12,
  HuilesGraisses = 13,
  Hydrocarbure = 14,
  Verbale = 15,
  Physique = 16,
  Accueil = 17,
  TriDechets = 18,
  Independant = 19,
  ASBL = 20,
  DepassementQuotas = 21,
  Reglement = 22,
  Autre = 23
}
